import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';

import PageWrapper from '../components/PageWrapper';
import ReadMore from '../components/ReadMore';
// import collaborationStats from '../../assets/images/collaborationStats.png';
// import test from '../../assets/test.pdf';
import ScrollToTop from '../components/ScrollToTop';
import CSIO_CommercialLine_WorkingGroup from '../../assets/CSIO_CommercialLine_WorkingGroup.pdf';
import NationalStandards_WorkingGroup from '../../assets/NationalStandards_WorkingGroup.pdf';
import ClDataStandardsGraphics from './components/ClDataStandardsGraphics';

const CollaborationPage = (props) => {
  const { height, width, MAX_WIDTH, isMobile } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageWrapper height={height} showHeaderLogo isMobile={isMobile}>
      {/* <div className="backgroundRectangle" style={{
            position: 'absolute',
            height: 1200,
            width,
            zIndex: -1
          }} />
          <div className="backgroundArrow" style={{
        position: 'absolute',
        height: 3400,
        width,
        zIndex: -1,
      }} /> */}
      <Row>
        <Col>
          <h2 style={{ marginTop: 120 }}>
            COLLA{isMobile && "-"}{isMobile && <br />}BORATION
          </h2>
          <p style={{ marginTop: 30 }}>
            Collaboration is in our DNA – we were founded on the need to work together to achieve more. 2021 will be remembered as the year when the ways we collaborated changed forever.</p>
          <p>
            Despite COVID-19 halting in-person meetings, we’re proud that we could still connect all of our stakeholders – brokers, insurers, vendors and associations.
          </p>
          <p>
            Thanks to our members, we didn’t miss a step. We were able to continue collaborating and progressing towards industry innovation.
          </p>
          <h3
            id="commercial-lines-data-standards"
            tabIndex="-1"
            style={{ marginTop: 60, textAlign: 'center' }}>
            COMMERCIAL LINES DATA STANDARDS
          </h3>
          <p style={{ marginTop: 30 }}>
            Commercial Lines (CL) is evolving. CSIO’s CL Data Standards are robust and ready for implementation across the industry.
          </p>
          <p style={{
            marginBottom: 30
          }}>
            Standardizing underwriting questions accelerates information flow between insurers and brokers. Insurers obtain accurate, structured data and can classify the risk and automate quotes. It all adds up to brokers providing better value and service to their commercial lines clients.
          </p>
          <ReadMore asA title="WATCH VIDEO" href="https://www.csio.com/data-standards/xml-edi-standards/commercial-lines-data-standards" target="_blank" rel="noreferrer" />
          <div style={{ marginTop: 60, backgroundColor: '#F3F5ED', padding: 20 }}>
            <p className="detailsQuote">
              “The absence of Data Standards can be costly. Standardizing the questions and the data collected helps support workflow efficiencies between insurers and their broker partners by improving the speed of information exchange, therefore strengthening the value proposition with our broker partners.”          </p>
            <span className="detailsAuthorText">Dave Smiley</span>
            <span className="valueExecDetail">
              , Chief Operating Officer, Unica Insurance Inc
            </span>
          </div>

          <h4
            style={{ marginTop: 60, textAlign: 'center' }}>
            CL Data Standards Highlights
            </h4>
          <ClDataStandardsGraphics />
          <h3 style={{ marginTop: 60, textAlign: 'center' }} id="working-groups" tabIndex="-1">
            WORKING GROUPS
          </h3>
          <p style={{ marginTop: 30 }}>
            Working groups have representatives from across the industry. While they spend countless hours reviewing and implementing solutions, they provide another important service: they create another channel for CSIO members to influence Standards and innovation. Participating as a member of a working group or providing information and feedback to working groups gives every CSIO member a voice.
          </p>
          <p>
            We thank all of the members who have given their time to these Working Groups:
          </p>
          <h4 style={{ marginTop: 30, fontFamily: 'Montserrat Bold', fontSize: 20 }}>
            Commercial Lines Data Standards Working Group:
            </h4>
          <p style={{ marginTop: 10 }}>
            Insurers, vendors and IBAC representatives make up this Working Group. They meet regularly to set the standard for real-time commercial quoting. A list of Working Group members can be found <a href={CSIO_CommercialLine_WorkingGroup} target="_blank" rel="noreferrer" className="detailsLink" aria-label="Open the CSIO commercial line working group pdf in a new tab">here</a>.
            </p>
          <h4 style={{ marginTop: 30, fontFamily: 'Montserrat Bold', fontSize: 20 }}>
            National Standards Working Group:
            </h4>
          <p style={{ marginTop: 10 }}>
            CSIO Data Standards are living documents. The Working Group keeps them fresh and in sync with emerging technologies. As products and information needs change, the Working Group ensures that the data Standards change with them. A list of Working Group members can be found <a href={NationalStandards_WorkingGroup} target="_blank" rel="noreferrer" className="detailsLink" aria-label="Open the CSIO national standards working group pdf in a new tab">here</a>.
            </p>

        </Col>
      </Row>
      <ScrollToTop height={height} width={width} maxWidth={MAX_WIDTH} />
    </PageWrapper>
  )
}

export default CollaborationPage;
